import React, { useEffect, useState } from 'react'
const Close = require('../../assets/icons/modal/Close.svg')

export default function CustomModal({ buttonText, modalContent, onclickOpen, isShowContent, modalID , hideCloseIcon, noCloseIcon, isErrorModalStyle, setIsErrorModalStyle, setIsExportAll }) {
  const [modalFlag, setModalFlag] = useState(false)
  useEffect(() => {
  // Get the modal
    var modal = document.getElementById("myModal")
    // Get the button that opens the modal
    var btn = document.getElementById("myBtn")
    // Get the <span> element that closes the modal
    var span = document.getElementsByClassName("close")[0]
    // When the user clicks on the button, open the modal
    if ((btn && modalFlag) || isShowContent) {
      modal.style.display = "block"
    }
    // When the user clicks on <span> (x), close the modal
    if (span && isShowContent) {
      span.onclick = function () {
        modal.style.display = "none"
        onclickOpen(true)
      }
    }

    let modalContent = document.querySelector(".modal-content")
    const tabletSize = "595"
    if (modalContent) {
      if (isErrorModalStyle && (window.innerWidth > tabletSize)) {
        modalContent.style.width = "568px"
        modalContent.style.height = "398px"
      } else if (isErrorModalStyle && (window.innerWidth < tabletSize)) {
        modalContent.style.height = "100vh"
      } else {
        modalContent.style.width = ''
        modalContent.style.height = ''
      }
    }

    // When the user clicks anywhere outside of the modal, close it
    window.onclick = function (event) {
      if (event.target === modal) {
        modal.style.display = "none"
        onclickOpen && onclickOpen(true)
        setIsErrorModalStyle(false)
        noCloseIcon(false)
        setIsExportAll && setIsExportAll(false)
      }
    }
  })
  
  const btnClick = () => {
    setModalFlag && setModalFlag(true)
    onclickOpen && onclickOpen(true)
  }

  return (
    <div>
      {!isShowContent && <div id="myBtn" className="buttonmodal" onClick={btnClick}><span className="modalbtn-text">{buttonText}</span></div>}
      <div id={"myModal"} className="modal">
        <div className={!isErrorModalStyle ?"modal-content" : 'modal-content-errormodal'}>
          {!hideCloseIcon ? <div style={{ backgroundColor: "rgb(238, 238, 238)" }}>
            <span className="close"  data-test="modalContent">
              <img src={Close} alt='close-button' className="mouse-pointer"/> 
            </span>
          </div> : null
          }
          {modalContent}
        </div>
      </div>
    </div>
  )
}
